var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNaverMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4443 13.8786L8.1896 0.52002H0.519531V25.48H8.55472V12.1214L17.8095 25.48H25.4795V0.52002H17.4443V13.8786Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.96,
    height: 24.96,
    fill: "white",
    transform: "translate(0.519531 0.52002)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaverMobile);
export default __webpack_public_path__ + "static/media/naver-mobile.7111322e2cf4fb45c8d5f43f0f4f8ce6.svg";
export { ForwardRef as ReactComponent };